import React, { Component } from 'react';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import ReportList from '~/containers/reportList/reportList';

export default class UpcomingBrewReports extends Component {
  render() {
    return (
      <Page>
        <TitleBar back="/reports" backText="Reports" title="Brew transfer notification reports" />
        <ReportList reportType="TRANSFER_BREW" reportFileName="transfer_brew" />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/brewTransferReports/brewTransferReports.jsx